import React, { Component } from "react"
import { IJobDocument, ITimeoffFilter } from "../../../models"
import JobsChip from "../../job/JobsChip"
import strings from "../../../localization/strings"
import * as api from "../../../api"

interface IProps {
    editFilterTemplate?: ITimeoffFilter
    checkValidate?(isValidate: boolean): void
}
interface IState {
    filterData: ITimeoffFilter
    selectedJobs: IJobDocument[]
}

export default class AddTimeoffFilterTemplateDialogContainer extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            filterData: props.editFilterTemplate ?
                props.editFilterTemplate :
                {
                    Id: "",
                    Name: "",
                    JobIds: []
                } as ITimeoffFilter,
            selectedJobs: []
        }
    }

    componentDidMount() {
        this.state.filterData && this.state.filterData.JobIds && this.state.filterData.JobIds.length > 0 &&
            api.getJobsByIds(this.state.filterData.JobIds).then(res =>
                this.setState({ selectedJobs: res.data })
            )
    }

    render() {
        const { filterData } = this.state
        return (
            <div style={{ marginTop: 10 }}>
                <JobsChip
                    multiSelectable
                    error={null}
                    label={strings.Filter_by_Selected_Jobs}
                    labelStyle={{ fontSize: 16 }}
                    selectedJobs={this.state.selectedJobs}
                    handleSave={selectedJobs => this.setState({
                        selectedJobs,
                        filterData: { ...filterData, JobIds: selectedJobs.map(i => i.Id) }
                    })}
                />
            </div>
        )
    }
}
